import React from "react";
import { PageShell, Section, Bullets } from "../components/PageShell";

const EMAIL = "info@miseone.eu";

export const TermsOfService = () => (
  <PageShell eyebrow="Legal" title="Terms of Service" testId="terms-page">
    <p>
      These terms describe the agreement between you and MiseOne when you use our
      website or our application. By using either, you agree to them.
    </p>

    <Section heading="The service">
      <p>
        MiseOne is an operating system built for professional kitchens. It helps you plan
        menus, manage inventory, track deliveries, run daily checks and see how your
        kitchen is really working — in one connected place.
      </p>
      <p>
        Some features may change over time as the product evolves. When something
        material changes, we will let you know.
      </p>
    </Section>

    <Section heading="Your responsibilities">
      <Bullets
        items={[
          "Give us accurate information when you sign up or book a demo.",
          "Keep your account credentials safe. You are responsible for activity that happens through your account.",
          "Use MiseOne for its intended purpose — running a professional kitchen. Do not misuse the service, attempt to break it, or use it to break the law.",
          "If you invite team members, make sure they follow these terms too.",
        ]}
      />
    </Section>

    <Section heading="Intellectual property">
      <p>
        The MiseOne brand, product, interface, code and content belong to MiseOne. You
        may use them only as part of the service.
      </p>
      <p>
        The operational data you enter into MiseOne (your menus, recipes, inventory,
        deliveries, checks and so on) belongs to you. We only process it to run the
        service on your behalf.
      </p>
    </Section>

    <Section heading="Service availability">
      <p>
        We work to keep MiseOne available and reliable, but we cannot guarantee zero
        downtime. We may perform maintenance, release updates or briefly interrupt the
        service to fix issues. We will do our best to minimise the impact on kitchens
        during service hours.
      </p>
    </Section>

    <Section heading="Limitation of liability">
      <p>
        To the fullest extent permitted by law, MiseOne is not liable for indirect or
        consequential losses (such as lost profits, lost data or business interruption)
        arising from your use of the service. Nothing in these terms limits any liability
        that cannot be limited under applicable law.
      </p>
    </Section>

    <Section heading="Ending the agreement">
      <p>
        You can stop using MiseOne at any time. We may suspend or end access if the terms
        are broken, or if we are required to do so by law. On request, we will provide a
        reasonable way to export your data.
      </p>
    </Section>

    <Section heading="Governing law">
      <p>
        These terms are governed by the laws of Finland. Any dispute that cannot be
        resolved amicably will be handled by the competent courts of Helsinki, Finland.
      </p>
    </Section>

    <Section heading="Contact">
      <p>
        Questions about these terms? Write to{" "}
        <a href={`mailto:${EMAIL}`} className="text-[#EA6A43] underline-offset-4 hover:underline">
          {EMAIL}
        </a>
        .
      </p>
    </Section>
  </PageShell>
);

export default TermsOfService;
